import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { StoreMode } from 'src/app/core/enums';
import { StoreResponse } from 'src/app/core/models/StoreResponse';
import { ChannelSecService } from '../channelsec/channelsec.service';
import { ChannelService } from '../channel/channel.service';
import { ChannelSec } from '../channelsec/channelsec.model';
import { ChannelSectionListResponse } from 'src/app/core/models/ChannelSectionListResponse';

@Injectable()
export class DefaultService {

  popupStoreMsg = new Subject<StoreResponse>();
  showStorePopupMsg = new Subject<boolean>();

  channelSecData: ChannelSec[] = null;
  openSearchFilter$ = new Subject<{displaySearch, displayFilter}>();
  openOrderTypeHome$ = new Subject<boolean>();
  displaySplashNews$ = new Subject<ChannelSectionListResponse[]>();

  constructor(
    private channelSecService: ChannelSecService,
    private channelService: ChannelService,
  ) {
    this.channelSecService.get(StoreMode.Internal).subscribe((data: ChannelSec[]) => {
      this.channelSecData = data;
    });
  }

  showOtherStoreDialog(content: StoreResponse) {
    this.showStorePopupMsg.next(true);
    this.popupStoreMsg.next(content);
  }

  isChannelSecDataEmpty(): boolean {
    return this.channelSecData.length === 0 ? true : false;
  }

  async recallChannelSecData() {
    await this.channelService.recallGetChannelData();
  }

  searchFilterDialogObserve() {
    return this.openSearchFilter$.asObservable();
  }

  showSearchFilterDialog(displaySearch: boolean, displayFilter: boolean) {
    this.openSearchFilter$.next({
      displaySearch: displaySearch,
      displayFilter: displayFilter
    });
  }

  showOrderTypeHome(open: boolean) {
    this.openOrderTypeHome$.next(open);
  }
}
